var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('marionette');
var Approvers = require('QuestionnaireApprovers');
var CustomFields = require('QuestionnaireCustomFields');
var DialogConfirmation = require('DialogConfirmation');
var Entities = require('Entities');
var Labels = EY.Consultation.Labels;
var Lookups = EY.Consultation.Lookups;
var Resources = EY.Consultation.Resources;
var TRIM_LENGTH = 50;

var Layout = Marionette.View.extend({
    events: {
        'click @ui.create': 'create',
        'click @ui.save': 'save',
        'click @ui.tabs': 'tabs'
    },
    regions: {
        approvers: '#approvers',
        buttons: '#buttons',
        fields: '#fields',
        questions: '#questions'
    },
    template: '#questionnaire',
    ui: {
        approvers: '#approvers-nav',
        create: '#create',
        geography: '#geography',
        save: '#save',
        tabs: '.nav-tab'
    },
    onRender: function () {
        this.ui.approvers.addClass(this.options.approvers.any({ configurable: true }) ? '' : 'hidden');
        this.ui.geography.html(_.findWhere(Resources.Geography, { id: this.model.get('geographyId') }).text);
    },
    create: function () {
        module.exports.start({
            questionnaire: new Entities.Questionnaire({
                answers: Resources.Questions,
                areaId: this.model.get('areaId'),
                countryId: this.model.get('countryId'),
                regionId: this.model.get('regionId')
            })
        });
    },
    save: function () {
        context = this;
        DialogConfirmation.show({
            message: Labels.MSG026
        }).done(function () {
            context.model.save({
                answers: context.options.answers.toJSON(),
                approvers: context.options.approvers.toJSON(),
                fields: context.options.fields.toJSON()
            });
        });
    },
    tabs: function (e) {
        this.ui.tabs.removeClass("active");
        this.$(e.currentTarget).addClass('active');
    }
});

var QuestionLayout = Marionette.View.extend({
    className: 'question-left-border',
    modelEvents: {
        'change': 'update'
    },
    regions: {
        answerContainer: '#answerContainer'
    },

    template: '#questionnaireQuestionTemplate',
    ui: {
        answer: '#answer',
        controls: '.question-controls',
        question: '#question',
        status: '#status'
    },
    onRender: function () {
        this.update();
        this.$el.addClass(this.model.get('visible') ? '' : 'hidden');
        this.ui.question.html(Labels['Question_' + this.model.id]);
    },
    update: function () {
        var answer = this.model.get('answer');

        if (this.model.get('questionTypeId') === Lookups.QuestionType.RadioButton) {
            answer = Labels[_.findWhere(this.model.get('choices'), { selected: true }).id];
        } else if (this.model.get('questionTypeId') === Lookups.QuestionType.Checkbox) {
            answer = _.values(_.pick(Labels, _.pluck(_.filter(this.model.get('choices'), { selected: true }), 'id'))).join();
        } else if (this.model.get('questionTypeId') === Lookups.QuestionType.Boolean) {
            answer = Labels[this.model.get('answer') ? 'Yes' : 'No'];
        }
        this.ui.answer.html(answer.length > TRIM_LENGTH ? answer.substr(0, TRIM_LENGTH) + '...' : answer);
        this.ui.controls.addClass(this.model.get('questionTypeId') === Lookups.QuestionType.Divider ? 'hidden' : '');
    }
});

var Divider = Marionette.View.extend({
    template: _.noop
});

var Text = Marionette.View.extend({
    template: '#questionnaireTextBox',
    events: {
        'blur @ui.answer': 'update'
    },
    ui: {
        answer: '#answer'
    },
    update: function () {
        this.model.set('answer', this.ui.answer.val());
    }
});

var TextArea = Text.extend({
    template: '#questionnaireTextArea'
});

var RadioButton = Marionette.View.extend({
    template: '#questionnaireRadioButton',
    events: {
        'click @ui.radio': 'selectionChanged'
    },
    ui: {
        radio: '#radio'
    },
    onRender: function () {
        this.ui.radio.prop('name', 'radioGroup' + this.options.questionOrder);
        this.ui.radio.prop('checked', this.model.get('selected') === true);
    },
    selectionChanged: function () {
        this.trigger('selection:changed', this);
    }
});

var RadioButtons = Marionette.CollectionView.extend({
    childView: RadioButton,
    childViewEvents: {
        'selection:changed': 'selectionChanged'
    },
    childViewOptions: function () {
        return {
            questionOrder: this.model.get('order')
        };
    },
    initialize: function () {
        this.collection = new Backbone.Collection(this.model.get('choices'));
    },
    selectionChanged: function (childView) {
        this.collection.each(function (model) {
            model.set('selected', false);
        });
        childView.model.set('selected', true);
        this.model.set('choices', this.collection.toJSON());
    }
});

var Checkbox = Marionette.View.extend({
    events: {
        'click @ui.check': 'selectionChanged'
    },
    ui: {
        check: '#check'
    },
    template: '#questionnaireCheckBox',
    onRender: function () {
        this.ui.check.prop('checked', this.model.get('selected') === true);
    },
    selectionChanged: function () {
        this.model.set('selected', this.ui.check.prop('checked'));
        this.trigger('selection:changed', this);
    }
});

var Checkboxes = Marionette.CollectionView.extend({
    childView: Checkbox,
    childViewEvents: {
        'selection:changed': 'selectionChanged'
    },
    initialize: function () {
        this.collection = new Backbone.Collection(this.model.get('choices'));
    },
    selectionChanged: function () {
        this.model.set('choices', this.collection.toJSON());
    }
});

var Switch = Marionette.View.extend({
    events: {
        'click @ui.answer': function (e) { this.model.set('answer', e.target.checked); }
    },
    template: '#questionaireBoolean',
    ui: {
        answer: '.switch-checkbox'
    },
    onRender: function () {
        this.ui.answer.attr('checked', this.model.get('answer'));
    }
});

var Questions = Marionette.CollectionView.extend({
    childView: function (item) {
        var view = '';

        switch (item.get('questionTypeId')) {
            case Lookups.QuestionType.Text:
                view = Text;
                break;
            case Lookups.QuestionType.TextArea:
                view = TextArea;
                break;
            case Lookups.QuestionType.RadioButton:
                view = RadioButtons;
                break;
            case Lookups.QuestionType.Checkbox:
                view = Checkboxes;
                break;
            case Lookups.QuestionType.Divider:
                view = Divider;
                break;
            case Lookups.QuestionType.Boolean:
                view = Switch;
                break;
        }
        return view;
    },
    filter:function(item){
        return item.get('questionTypeId') !== Lookups.QuestionType.Number;
    },
    buildChildView: function (child, ChildViewClass) {
        var view = new QuestionLayout({
            model: child
        });

        view.on('render', function () {
            this.getRegion('answerContainer').show(new ChildViewClass({
                model: child
            }));
        });
        return view;
    }
});

module.exports.start = function (options) {
    var consultation = require('Consultation');
    var questionnaire = options.questionnaire;
    var answers = new Entities.Questions(questionnaire.get('answers'));
    var approvers = new Entities.ApproverGroups(questionnaire.get('approvers').length ? questionnaire.get('approvers') : Resources.ApproverGroup);
    var available = new Entities.ApproverGroups();
    var fields = new Entities.CustomFields(questionnaire.get('fields'));
    var layout = new Layout(_.extend({
        answers: answers,
        available: available,
        fields: fields,
        model: questionnaire,
        approvers: approvers
    }, options));

    consultation.show({ view: layout });
    layout.getRegion('questions').show(new Questions({
        collection: answers
    }));

    Approvers.start({
        available: available,
        mapped: approvers,
        region: layout.getRegion('approvers')
    });

    CustomFields.start({
        collection: fields,
        region: layout.getRegion('fields')
    });

    // Note: The mapping feature is disabled for now; in js and html!
    //approvers.reset(questionnaire.get('approvers'));
    //approvers.each(function (approver) {
    //    available.remove(approver.id)
    //});
};


// WEBPACK FOOTER //
// ./js/Modules/Questionnaire/Questionnaire.js